export const checkLocationIsOkinawa = (lat, lng) => {
  if (!lat || !lng) {
    return false;
  }

  const north = 26.903217194923986;
  const east = 128.34116602875577;
  const south = 25.969025991049005;
  const west = 127.56206909165053;

  return lat <= north && lat >= south && lng <= east && lng >= west;
};

export const sleep = (ms = 1000) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });

//Version Control - https://gist.github.com/TheDistantSea/8021359
export const versionCompare = (v1 = '', v2, options) => {
  const lexicographical = options && options.lexicographical;
  const zeroExtend = options && options.zeroExtend;
  let v1parts = v1.split('.');
  let v2parts = v2.split('.');

  function isValidPart(x) {
    return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
  }

  if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
    return NaN;
  }

  if (zeroExtend) {
    while (v1parts.length < v2parts.length) v1parts.push('0');
    while (v2parts.length < v1parts.length) v2parts.push('0');
  }

  if (!lexicographical) {
    v1parts = v1parts.map(Number);
    v2parts = v2parts.map(Number);
  }

  for (let i = 0; i < v1parts.length; ++i) {
    if (v2parts.length === i) {
      return 1;
    }

    if (v1parts[i] === v2parts[i]) {
      continue; // eslint-disable-line no-continue
    } else if (v1parts[i] > v2parts[i]) {
      return 1;
    } else {
      return -1;
    }
  }

  if (v1parts.length !== v2parts.length) {
    return -1;
  }

  return 0;
};

/**
 * @param {number} x
 */
const rad = (x) => (x * Math.PI) / 180;
/**
 * return distance in meters
 * @param {number} lat1
 * @param {number} lng1
 * @param {number} lat2
 * @param {number} lng2
 */
export const getDistanceBetweenTwoLatLng = function (lat1, lng1, lat2, lng2) {
  const R = 6378137; // Earth’s mean radius in meter
  const dLat = rad(lat2 - lat1);
  const dLong = rad(lng2 - lng1);
  const aa = Math.sin(dLat / 2) * Math.sin(dLat / 2);
  const bb =
    Math.cos(rad(lat1)) *
    Math.cos(rad(lat2)) *
    Math.sin(dLong / 2) *
    Math.sin(dLong / 2);
  const a = aa + bb;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return d; // returns the distance in meter
};
